import styled from 'styled-components';
import { colorScheme } from '../../theme';

export const JsonPreview = styled.pre`
  background-color: ${colorScheme.card.background};
  border: 1px solid ${colorScheme.card.border};
  border-radius: 4px;
  padding: 16px;
  font-size: 12px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
`;
